import {MeasuringReason} from "@app/strain/config/measuring-reasons/models/measuring-reason.model";
import {StrainImageModel} from "@app/strain/common/models/view-measurement-models/strain-image.model";
import {StrainMeasurementGageValuesModel} from "@app/strain/common/models/view-measurement-models/strain-measurement-gage-values.model";
import { StrainMeasurementGageDetailsModel } from "@app/strain/common/models/view-measurement-models/strain-measurement-gage-details.model";


export class StrainMeasurementChartModel {
    public title: string;
    public reason: MeasuringReason;
    public observations: string;
    public minValue: number;
    public minValueGageNumber: number;
    public maxValue: number;
    public maxValueGageNumber: number;
    public measurementChart: StrainImageModel
    public gageValues: StrainMeasurementGageValuesModel[];

    constructor(entry: any = {}) {
        this.title = entry.title;
        this.reason = entry.reason ? new MeasuringReason(entry.reason) : null;
        this.observations = entry.observations;
        this.minValue = entry.minValue;
        this.minValueGageNumber = entry.minValueGageNumber;
        this.maxValue = entry.maxValue;
        this.maxValueGageNumber = entry.maxValueGageNumber;
        this.measurementChart = entry.measurementChart ? new StrainImageModel(entry.measurementChart) : null;
        this.gageValues = entry.gageValues
            ? entry.gageValues.map(item => new StrainMeasurementGageValuesModel(item))
            : [];
    }
}








